export enum PaymongoPaymentMethodEnum {
  card = 'card',
  gcash = 'gcash',
  payMaya = 'paymaya',
  grabPay = 'grab_pay',
  otc = 'otc'
}
